import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Bento } from "@/components/landing/Bento";
import { Categories } from "@/components/landing/Categories";
import { RecentEvents, PhotographersSection } from "@/components/landing/Showcase";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ProposalForm } from "@/components/landing/ProposalForm";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { WhatsAppBanner } from "@/components/site/WhatsApp";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Hero />
      <Marquee />
      <Bento />
      <Categories />
      <RecentEvents />
      <HowItWorks />
      <WhatsAppBanner />
      <PhotographersSection />
      <ProposalForm />
      <FinalCTA />
    </main>
  );
}
